/**
 * 메뉴·도움말이 쓰는 그림 목록 한 곳.
 *
 * `menu.ts` 와 `helpContent.ts` 는 이름만 안다(문자열). 그림으로 바꾸는 일은 화면 몫인데,
 * 사이드바와 도움말이 각자 표를 들면 같은 메뉴가 두 곳에서 다른 그림으로 보인다.
 */
import {
  Activity, AppWindow, ArrowLeftRight, BarChart3, BookOpen, Briefcase, Building, Building2,
  Cable, Car, CircleAlert, CircleHelp, Coins, Cog, CreditCard, Factory, FileCode, FileText,
  Gauge, HardHat, History, IdCard, Layers, LayoutDashboard, LifeBuoy, MapPin, Megaphone,
  MessageSquare, Network, PlugZap, Radio, Receipt, ReceiptText, Settings2, ShieldCheck,
  Shuffle, Sigma, Tag, Tags, Ticket, TriangleAlert, User, UserCog, Users, Wrench,
  type LucideIcon,
} from "lucide-react";

export const ICONS: Record<string, LucideIcon> = {
  Activity, AppWindow, ArrowLeftRight, BarChart3, BookOpen, Briefcase, Building, Building2,
  Cable, Car, CircleAlert, CircleHelp, Coins, Cog, CreditCard, Factory, FileCode, FileText,
  Gauge, HardHat, History, IdCard, Layers, LayoutDashboard, LifeBuoy, MapPin, Megaphone,
  MessageSquare, Network, PlugZap, Radio, Receipt, ReceiptText, Settings2, ShieldCheck,
  Shuffle, Sigma, Tag, Tags, Ticket, TriangleAlert, User, UserCog, Users, Wrench,
};

/** 메뉴 이름 앞의 「* 」는 목업 진행 표시다(2026-09-11). 사람에게 보이는 글에서는 뗀다. */
export function plainLabel(label: string): string {
  return label.replace(/^\*\s*/, "");
}
